import React from 'react'

const IconGreenArrowV2 = () => {
  return (
    <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.28613 0.459961L10.2861 5.45996L0.286133 5.45996L5.28613 0.459961Z" fill="#21B979" />
    </svg>    
  )
}

export default IconGreenArrowV2
